import React from "react";
import { noop } from "lodash";

import DataTableBody from "./DataTableBody";
import Styles from "./DataTable.scss";

const DataTable = ({
  blockName = "data-table",
  onSortChange = noop,
  sortData,
  dataTest,
  ...restProps
}) => {
  return (
    <div className={Styles.dataTable} data-test={dataTest}>
      <DataTableBody
        {...restProps}
        onSortChange={onSortChange}
        sortData={sortData}
      />
    </div>
  );
};

export default React.memo(DataTable);
